import type { IconProps } from './IconProps';

export const GlobeIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_2976_2495)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.13058 7.24992H4.62365C4.77841 5.49544 5.35376 3.80965 6.29345 2.33313C4.08918 2.99608 2.42658 4.91 2.13058 7.24992ZM8.00016 2.50404C6.95414 3.88401 6.30685 5.52607 6.13041 7.24992H9.86992C9.69347 5.52607 9.04618 3.88401 8.00016 2.50404ZM9.86992 8.74992C9.69347 10.4738 9.04618 12.1158 8.00016 13.4958C6.95414 12.1158 6.30685 10.4738 6.13041 8.74992H9.86992ZM4.62365 8.74992H2.13058C2.42658 11.0898 4.08918 13.0038 6.29345 13.6667C5.35375 12.1902 4.77841 10.5044 4.62365 8.74992ZM9.70688 13.6667C10.6466 12.1902 11.2219 10.5044 11.3767 8.74992H13.8697C13.5737 11.0898 11.9111 13.0038 9.70688 13.6667ZM13.8697 7.24992H11.3767C11.2219 5.49544 10.6466 3.80965 9.70688 2.33313C11.9111 2.99608 13.5737 4.91 13.8697 7.24992ZM0.583496 7.99992C0.583496 3.90381 3.90405 0.583252 8.00016 0.583252C12.0963 0.583252 15.4168 3.90381 15.4168 7.99992C15.4168 12.096 12.0963 15.4166 8.00016 15.4166C3.90405 15.4166 0.583496 12.096 0.583496 7.99992Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2976_2495">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
